var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBellNotif(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8261 2C8.46436 2 5.73914 4.72522 5.73914 8.08696V10.1795C5.73914 11.2798 5.03006 12.2422 4.46647 13.1872C4.1702 13.684 4 14.2647 4 14.8851C4 16.488 5.1452 17.8633 6.73291 18.0834C8.3096 18.3021 10.2797 18.522 11.8261 18.522C13.3724 18.522 15.3426 18.3021 16.9193 18.0834C18.507 17.8633 19.6522 16.488 19.6522 14.8851C19.6522 14.2647 19.482 13.684 19.1857 13.1872C18.6221 12.2422 17.9131 11.2798 17.9131 10.1795V8.08696C17.9131 4.72522 15.1878 2 11.8261 2Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 20.834C13.5326 21.5369 12.7335 22.0002 11.8261 22.0002C10.9187 22.0002 10.1195 21.5369 9.65218 20.834",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellNotif);
export default __webpack_public_path__ + "static/media/bell_notif.6c4e63f68f916258cac7070a2195da22.svg";
export { ForwardRef as ReactComponent };